import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingService } from './app-routing.service';
import { environment } from '../environments/environment';
import { MsalGuard } from '@azure/msal-angular';
import {
  OktaAuthGuard,
} from '@okta/okta-angular';
import { AppAuthGuard } from './app.auth.guard';

/**
 * window reference
 */
const _window: any = window;

/**
 * check if ApiKey is used
 */
const apiKeyInfo = _window.apiKeyInfo;

/**
 * Auth guards
 */
const authGuardArray: Array<any> = [];

if (!apiKeyInfo) {
  if (environment.UseMsal) {
    authGuardArray.push(MsalGuard);
  }
  if (environment.UseOkta) {
    authGuardArray.push(OktaAuthGuard);
  }
}

/**
 * Available routes
 */
const APP_ROUTES: Routes = [
  {
    //used for MSAL login redirect
    path: 'login',
    redirectTo: ''
  },
  {
    path: 'id_token',
    redirectTo: ''
  },
  {
    path: 'access_token',
    redirectTo: ''
  },
  {
    path: 'pd',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/project-valuation/project-valuation.module').then(m => m.ProjectValuationModule)
  },
  {
    path: 'cmp',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/comparables/comparables.module').then(m => m.ComparablesModule)
  },
  {
    path: 'set',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/app-settings/app-settings.module').then(m => m.AppSettingsModule)
  },
  {
    path: 'dataverse',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/app-dataverse/app-dataverse.module').then(m => m.AppDataverseModule)
  },
  {
    path: 'raci',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/raci/raci.module').then(m => m.RaciModule)
  },
  {
    path: 'user-dashboard',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/user-dashboard/user-dashboard.module').then(m => m.UserDashboardModule)
  },
  {
    path: 'rd',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/report-designer/report-designer.module').then(m => m.ReportDesignerModule)
  },
  {
    path: 'status',
    canActivate: authGuardArray,
    loadChildren: () => import('./modules/status/status.module').then(m => m.StatusModule)
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./modules/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  },
  {
    path: '**',
    redirectTo: '/pd',
    pathMatch: 'full'
  }
];

/**
 * App routing module
 */
@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { enableTracing: false, useHash: true })], //Use enableTracing to enable router debugging
  exports: [RouterModule],
  declarations: [],
  providers: [
    AppRoutingService,
    AppAuthGuard
  ]
})
export class AppRoutingModule { }
